var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPregunta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10.3569C10 9.36237 10.4609 8.40854 11.2814 7.70528C12.1019 7.00202 13.2147 6.60693 14.375 6.60693H15.625C16.7853 6.60693 17.8981 7.00202 18.7186 7.70528C19.5391 8.40854 20 9.36237 20 10.3569C20.046 11.1685 19.8271 11.9731 19.3762 12.6494C18.9253 13.3258 18.2668 13.8373 17.5 14.1069C16.7332 14.4665 16.0747 15.1485 15.6238 16.0503C15.1729 16.9521 14.954 18.0248 15 19.1069",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 24.1069V24.1194",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.356934)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPregunta);
export default __webpack_public_path__ + "static/media/Pregunta.f1f1ee0da8e5cd01003f5189a9201cd9.svg";
export { ForwardRef as ReactComponent };